module.exports = __webpack_public_path__ + "img/pic_bangkok.75de42ab.jpg";